var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.26 12.4867V7.39398H1.6775V12.4867H0.26ZM11.397 6.15668L11.0138 6.49738L11.257 6.95286C11.3371 7.10289 11.3787 7.27136 11.3777 7.4424C11.3777 7.73828 11.2517 8.01981 11.0347 8.21348L10.6515 8.55418L10.8948 9.00966C10.9749 9.15969 11.0164 9.32816 11.0155 9.4992C11.0155 9.79508 10.8895 10.0766 10.6725 10.2703L10.2892 10.611L10.5325 11.0665C10.6126 11.2165 10.6542 11.385 10.6533 11.556C10.6533 11.9577 10.4222 12.3199 10.0652 12.4849H2.7975V7.3366L4.53875 0.872115C4.58365 0.706423 4.68003 0.560244 4.8133 0.455727C4.94656 0.351209 5.10944 0.29405 5.27725 0.292911C5.41025 0.292911 5.5415 0.332361 5.6465 0.413055C5.81975 0.545752 5.9125 0.74659 5.902 0.959981L5.734 4.51769H11.236C11.5475 4.71315 11.74 5.0431 11.74 5.3856C11.74 5.68148 11.614 5.96122 11.397 6.15668Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.7f8c64d5f58e7ce38d71725fd77ecc2b.svg";
export { ForwardRef as ReactComponent };